import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Button, Form, Row, Col, Radio, Spin, Alert, message } from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import axiosInPosp from "../../Redux/axios/AxiosInPosp";
import { ONBDetils } from "../../Redux/actions/OnboardAction";
import "./onboard.css";
import axios from "axios";
import options from "./QuestionOptions";

function TrainingQuestion({ setCurrent, current, setSelectedContent }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const PospTok = useSelector((state) => state?.posp?.Posp);
  const [loading, setloading] = useState(false);
  const [BaseUrl, setBaseURL] = useState("");
  const [QuestionData, setQuestionData] = useState([]);
  const [error, setError] = useState(null);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [status, setStatus] = useState("");
  const optionsMapping = options;
  useEffect(() => {
    const BASEURL = process.env.REACT_APP_UAT_BASE_URL;
    setBaseURL(BASEURL);
    fetchQuestion();
    fetchData();
  }, []);

  const fetchQuestion = () => {
    setloading(true);
    axiosInPosp
      .get(`v1/posp/examination/questions`)
      .then((res) => {
        console.log(res);
        if (res?.status === 200) {
          const QuesData = res?.data;
          console.log("QuesData", QuesData);
          setQuestionData(QuesData);
        }

        setloading(false);
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
        if (err?.response.data.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
      });
  };
  const fetchData = () => {
    setloading(true);
    axiosInPosp
      .get(`v1/posp/profile/edit`)
      .then((res) => {
        console.log("v1/posp/profile/edit", res);
        const ProfData = res?.data?.profile;
        console.log(ProfData);
        if (ProfData?.kyc_status?.name === "QUALIFIED") {
          setStatus("QUALIFIED");
        }
        dispatch(ONBDetils(ProfData));
        setloading(false);
      })
      .catch((err) => {
        console.log(err?.response);
        setloading(false);
        if (err?.response.data.message === "Unauthenticated.") {
          dispatch({ type: "LOGOUT_POSP" });
          history.push("/");
        }
      });
  };
  const handleOptionChange = (questionId, selectedOption) => {
    setSelectedAnswers((prevState) => ({
      ...prevState,
      [questionId]: selectedOption,
    }));
  };
  console.log(selectedAnswers);
  const handleSubmit = () => {
    const unansweredQuestions = QuestionData?.filter(
      (q) => !selectedAnswers[q.id.toString()]
    );
    console.log("unansweredQuestions", unansweredQuestions);
    if (unansweredQuestions.length > 0) {
      setError(`Please answer all the questions before submitting.`);
      //   setSelectedContent("1");
      return;
    }
    const letterAnswers = Object.entries(selectedAnswers).map(
      ([question_id, answer]) => {
        const options =
          optionsMapping[
            QuestionData?.find((q) => q.id.toString() === question_id)
              .question_code
          ];
        const index = options.indexOf(answer);
        return {
          answer_key: String.fromCharCode(97 + index),
          question_id,
        };
      }
    );

    console.log("Selected Answers in Letter Format:", letterAnswers);
    setError(null);
    if (unansweredQuestions?.length === 0) {
      setloading(true);
      const answerArray = { answers: letterAnswers };
      const token = PospTok?.accessToken;

      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      };
      axios
        .post(`${BaseUrl}v1/posp/examination/answers`, answerArray, { headers })
        .then((res) => {
          console.log(res);
          const DataQues = res?.data;
          console.log(DataQues);
          if (DataQues?.message === "Answers submitted") {
            message.success(
              "Congratulation You Scored" + DataQues?.score + "%"
            );
            fetchData();
          }
          //   setSelectedContent("1");
          setloading(false);
        })
        .catch((err) => {
          console.log(err?.response);
          message.error(err?.response?.data?.message);
          //   if(err?.response?.message === "Your score was less than 50%. Please try again")
          setloading(false);
        });
    }
  };
  return (
    <>
      <Spin spinning={loading}>
        <div className="step-container">
          {status === "QUALIFIED" && (
            <p
              className="info-dwnld-txt"
              onClick={() => setSelectedContent("1")}
            >
              Go to profile & download Certificate
            </p>
          )}
          {QuestionData?.map((q, index) => (
            <div key={q.id} style={{ marginBottom: "20px" }}>
              <p style={{ fontWeight: "500" }}>
                {index + 1}. {q.question}
              </p>
              <Radio.Group
                onChange={(e) =>
                  handleOptionChange(q.id.toString(), e.target.value)
                }
                value={selectedAnswers[q.id.toString()]}
                disabled={status === "QUALIFIED"}
              >
                {optionsMapping[q.question_code]?.map((option, optIndex) => (
                  <Radio
                    key={optIndex}
                    value={option}
                    style={{ display: "block", paddingLeft: "20px" }}
                  >
                    {String.fromCharCode(97 + optIndex)}. {option}
                  </Radio>
                ))}
              </Radio.Group>
            </div>
          ))}
          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              style={{ marginBottom: "20px" }}
            />
          )}
        </div>
        {status === "QUALIFIED" ? (
          <Row gutter={24} className="justify-content-center">
            <Col span={6}>
              <Form.Item className="step-btn-nxt">
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={() => setCurrent(current - 1)}
                >
                  Back
                </Button>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item className="step-btn-nxt">
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={() => setSelectedContent("1")}
                >
                  Get Certificate
                </Button>
              </Form.Item>
            </Col>
          </Row>
        ) : (
          <Row gutter={24} className="justify-content-center">
            {current > 2 && (
              <Col span={6}>
                <Form.Item className="step-btn-nxt">
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={() => setCurrent(current - 1)}
                  >
                    Back
                  </Button>
                </Form.Item>
              </Col>
            )}
            <Col span={6}>
              <Form.Item className="step-btn-nxt">
                <Button type="primary" htmlType="submit" onClick={handleSubmit}>
                  Finish
                </Button>
              </Form.Item>
            </Col>
          </Row>
        )}
      </Spin>
    </>
  );
}

export { TrainingQuestion };
